// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1b12678c","455":"ba0e2fab","977":"b3b571a4"}[chunkId] + ".chunk.js";
};